// src/components/NightModeToggle.jsx
import React, { useState, useEffect } from 'react';
import './Navbar.css';

const NightModeToggle = () => {
    // Estado inicial basado en localStorage o preferencia del sistema
    const [isDarkMode, setIsDarkMode] = useState(() => {
        // Verificar si hay una preferencia guardada
        const savedTheme = localStorage.getItem('pf-theme');
        if (savedTheme) {
            return savedTheme === 'dark';
        }
        
        // Verificar preferencia del sistema
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        return prefersDark;
    });

    useEffect(() => {
        // Aplicar el tema al documento
        applyTheme(isDarkMode);
        
        // Escuchar cambios en la preferencia del sistema
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            // Solo cambiar si no hay preferencia guardada
            if (!localStorage.getItem('pf-theme')) {
                setIsDarkMode(e.matches);
            }
        };
        
        mediaQuery.addEventListener('change', handleChange);
        
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [isDarkMode]);

    const applyTheme = (darkMode) => {
        const root = document.documentElement;
        
        if (darkMode) {
            root.setAttribute('data-theme', 'dark');
            localStorage.setItem('pf-theme', 'dark');
        } else {
            root.setAttribute('data-theme', 'light');
            localStorage.setItem('pf-theme', 'light');
        }
        
        // También aplicar al body para compatibilidad
        document.body.setAttribute('data-theme', darkMode ? 'dark' : 'light');
        
        // Actualizar componentes Material-UI si es necesario
        updateMaterialUITheme(darkMode);
    };

    const updateMaterialUITheme = (isDark) => {
        // Esto actualizará componentes Material-UI si los estás usando
        const muiTheme = document.querySelector('.MuiScopedCssBaseline-root, .MuiCssBaseline-root');
        if (muiTheme) {
            muiTheme.style.backgroundColor = isDark ? '#121212' : '#f8f9fa';
            muiTheme.style.color = isDark ? '#e2e8f0' : '#1e293b';
        }
        
        // Actualizar cualquier componente que use --nav-* variables
        const elements = document.querySelectorAll('.MuiPaper-root, .MuiCard-root, .MuiAppBar-root');
        elements.forEach(el => {
            if (isDark) {
                el.style.setProperty('--nav-bg', 'var(--nav-bg-dark)');
                el.style.setProperty('--nav-text', 'var(--nav-text-dark)');
            } else {
                el.style.setProperty('--nav-bg', 'var(--nav-bg-light)');
                el.style.setProperty('--nav-text', 'var(--nav-text-light)');
            }
        });
    };

    const toggleTheme = () => {
        setIsDarkMode(!isDarkMode);
    };

    return (
        <button 
            className="night-mode-toggle"
            onClick={toggleTheme}
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
            title={isDarkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
        >
            <div className="toggle-track">
                <div className="toggle-thumb">
                    <span className="toggle-thumb-icon sun-glyph" aria-hidden="true">☀︎</span>
                    <span className="toggle-thumb-icon moon-glyph" aria-hidden="true">☾</span>
                </div>
            </div>
        </button>
    );
};

export default NightModeToggle;